module.exports = __webpack_public_path__ + "img/success.0b434682.svg";